import type { ReactNode } from "react";

/** Top-level page header: h1 + optional trailing actions (search, primary button). */
export function PageHeader({
  title,
  actions,
  footnote,
}: {
  title: string;
  actions?: ReactNode;
  footnote?: string;
}) {
  return (
    <div className="mb-6">
      <div className="flex flex-wrap items-center gap-4">
        <h1 className="font-sans text-[24px] font-bold tracking-[-0.3px] text-ge-primary">
          {title}
        </h1>
        {actions && <div className="ml-auto flex items-center gap-3">{actions}</div>}
      </div>
      {footnote && <p className="mt-2 text-[12px] text-ge-muted">{footnote}</p>}
    </div>
  );
}
